import About from "../components/about/About";
import Footer from "../components/footer/Footer";
import Header from "../components/Header";
const AboutRoute = () => {
  return (
    <>
      <Header />
      <About />
      <Footer />
    </>
  );
};
export default AboutRoute;
